var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useReducer } from 'react';
import axios from 'axios';
import { AuthContext } from './authProvider';
import { authReducer } from '../reducers';
export const AuthService = ({ children, userApi }) => {
    const reducer = useReducer(authReducer, {
        status: 'undetermined',
        userData: null,
        unauthenticatedUri: null,
    });
    const [state, setAuthState] = reducer;
    const status = state.status;
    const refreshing = state.refreshing;
    useEffect(() => {
        function isUserAuthenticated() {
            return __awaiter(this, void 0, void 0, function* () {
                //set auth state loading value to true.
                setAuthState({ type: 'AUTH_LOADING' });
                try {
                    // Checks if user is authenticated.
                    const userAuth = yield userApi();
                    //set auth state isAuthenticated value to true and save response.data in the state.
                    setAuthState({ type: 'AUTH_SUCCESS', payload: userAuth.data });
                }
                catch (error) {
                    //return auth state loading value to false.
                    setAuthState({ type: 'AUTH_FAILED' });
                }
            });
        }
        function updateUser() {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    // Get new username, change it in the UserInfo accordingly
                    const userAuth = yield userApi();
                    setAuthState({ type: 'AUTH_UPDATE', payload: userAuth.data.naam || '' });
                }
                catch (error) {
                    setAuthState({ type: 'AUTH_FAILED' });
                }
            });
        }
        if (status === 'undetermined') {
            isUserAuthenticated();
        }
        if (refreshing) {
            updateUser();
        }
    }, [status, setAuthState, state.refreshing]);
    useEffect(() => {
        // Add a response interceptor to handle 401 (Unauthorized) responses.
        const authInterceptor = axios.interceptors.response.use(response => {
            return response;
        }, error => {
            // Set application state isAuthenticated value to false.
            if (!axios.isCancel(error)) {
                if (error.response.status === 401) {
                    setAuthState({ type: 'AUTH_FAILED' });
                }
            }
            return Promise.reject(error);
        });
        return () => {
            axios.interceptors.response.eject(authInterceptor);
        };
    }, []);
    return _jsx(AuthContext.Provider, Object.assign({ value: reducer }, { children: children }));
};
